import React from "react";
import loadable from "@loadable/component";
import PropTypes from "prop-types";

import SplashText from "../../components/SplashText";
import { Section, Heading, ProjectList } from "./styles";
import ProjectCardsSkeleton from "./project-card-skeleton";

const ProjectCards = loadable(() => import("./project-card"));

const ProjectsSection = ({
  compensateHeaderGap = false,
  mode = "landing",
}) => {
  return (
    <Section
      name="projects"
      as="section"
      $compensateHeaderGap={compensateHeaderGap}
    >
      <Heading as={compensateHeaderGap ? "h1" : "h2"}>
        <SplashText variant="accent">Projects</SplashText>
      </Heading>
      <ProjectList>
        <ProjectCards
          mode={mode}
          fallback={<ProjectCardsSkeleton mode={mode} />}
        />
      </ProjectList>
    </Section>
  );
};

ProjectsSection.propTypes = {
  compensateHeaderGap: PropTypes.bool,
  mode: PropTypes.oneOf(["landing", "all"]),
};

export default ProjectsSection;
